import ActionTypes from '../constants';

const initialState = {
    insuranceTypes: {},
    insuranceType: {}
    // loading: false,
};

const insuranceTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETINSURANCETYPESUCCESS:
            return {
                ...state,
                insuranceTypes: action.payload,
            }
        case ActionTypes.GETINSURANCETYPEBYIDSUCCESS:
            return {
                ...state,
                insuranceType: action.payload,
            }
        default:
            return state;
    }
}

export default insuranceTypeReducer;